const PAGE_ID = {
  Vod: 'vod',
};

export { PAGE_ID };
